import { apiClient } from "./client";

export type DirectoryOrgInfo = {
  id: string;
  code: string;
  name: string;
  membership_kind: string;
};

export type DirectoryEntry = {
  id: string;
  display_name: string;
  first_name: string | null;
  last_name: string;
  phone: string | null;
  email: string | null;
  rpps: string | null;
  bio: string | null;
  languages: string[];
  has_photo: boolean;
  organizations: DirectoryOrgInfo[];
};

export async function listDirectory(params: {
  q?: string;
  organization_id?: string;
  limit?: number;
}): Promise<{ items: DirectoryEntry[]; total: number }> {
  const { data } = await apiClient.get<{ items: DirectoryEntry[]; total: number }>(
    "/api/v1/me/directory",
    { params },
  );
  return data;
}
